export const GET_ORDERS = 'GET_ORDERS';
export const SUCCESS_GET_ORDERS = 'SUCCESS_GET_ORDERS';
export const FAIL_GET_ORDERS = 'FAIL_GET_ORDERS';

export const GET_DAY_ORDERS = 'GET_DAY_ORDERS';
export const SUCCESS_GET_DAY_ORDERS = 'SUCCESS_GET_DAY_ORDERS';
export const FAIL_GET_DAY_ORDERS = 'FAIL_GET_DAY_ORDERS';

export const GET_USERS_ORDERS = 'GET_USERS_ORDERS';
export const SUCCESS_GET_USERS_ORDERS = 'SUCCESS_GET_USERS_ORDERS';
export const FAIL_GET_USERS_ORDERS = 'FAIL_GET_USERS_ORDERS';

export const EDIT_ORDER = 'EDIT_ORDER';

export const VALIDATE_ORDER = 'VALIDATE_ORDER';
export const SUCCESS_VALIDATE_ORDER = 'SUCCESS_VALIDATE_ORDER';
export const FAIL_VALIDATE_ORDER = 'FAIL_VALIDATE_ORDER';

export const CREATE_ORDER = 'CREATE_ORDER';
export const SUCCESS_CREATE_ORDER = 'SUCCESS_CREATE_ORDER';
export const FAIL_CREATE_ORDER = 'FAIL_CREATE_ORDER';

export const UPDATE_ORDER_IS_CONFIRMED = 'UPDATE_ORDER_IS_CONFIRMED';
export const SUCCESS_UPDATE_ORDER_IS_CONFIRMED = 'SUCCESS_UPDATE_ORDER_IS_CONFIRMED';
export const FAIL_UPDATE_ORDER_IS_CONFIRMED = 'FAIL_UPDATE_ORDER_IS_CONFIRMED';

export const UPDATE_ORDER_IS_COMPLETED = 'UPDATE_ORDER_IS_COMPLETED';
export const SUCCESS_UPDATE_ORDER_IS_COMPLETED = 'SUCCESS_UPDATE_ORDER_IS_COMPLETED';
export const FAIL_UPDATE_ORDER_IS_COMPLETED = 'FAIL_UPDATE_ORDER_IS_COMPLETED';

export const INIT_ORDER = 'INIT_ORDER';
